import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SetupService } from '../configuracoes/setup/setup.service';
import { UsuarioLogado } from '../seguranca/usuario/usuario-logado.model';
import { UsuarioService } from '../seguranca/usuario/usuario.service';
import { AuthService } from '../shared/auth/auth.service';
import { GlobalsVariablesService } from '../shared/service/global-variables.service';
import { MessageService } from '../shared/service/message.service';
import { LayoutThemeService } from '../shared/service/layout-theme.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: [
        './login.css',
        './login.responsive.css'
    ]
})
export class LoginComponent {

    public loginModel: {} = {};
    public statusLogin: boolean = true;
    private usuarioLogado: UsuarioLogado = new UsuarioLogado();
    public authToken;
    public errors;
    public exibirSenha: boolean = false;

    constructor(
        public _router: Router,
        public _messageService: MessageService,
        public _authService: AuthService,
        public _usuarioService: UsuarioService,
        public globalsVariablesService: GlobalsVariablesService,
        public cookieService: CookieService,
        public _setupService: SetupService,
        public layoutThemeService: LayoutThemeService
    ) {
        document.querySelector('body').classList.add('backLogin');
    }


    private logar() {
        this._authService.authenticate(this.loginModel).subscribe(res => {
            this.authToken = res.mensagem;
            if(res.nome != null  && res.nome != undefined ){
                this.globalsVariablesService.mensagensUteis.descricao = res.nome;
            }else{
                this.globalsVariablesService.mensagensUteis.descricao = null;
            }
            document.querySelector('body').classList.remove('backLogin');

            this._authService.autenticarUsuario(this.loginModel).subscribe(res => {
                this.usuarioLogado = res;
               
                if (this.usuarioLogado.pessoaNomeFantasia != '' && this.usuarioLogado.pessoaNomeFantasia != 'undefined') {
                    this._setupService.getSetup().then(setup => {
                        console.log('user')
                        console.log(this.usuarioLogado)
                        this.globalsVariablesService.setGlobalsVariables(this.usuarioLogado);
                        this.globalsVariablesService.setInformacoesSetup(setup);
                        this.cookieService.set('user', JSON.stringify(this.loginModel), 365);
                        
                        localStorage.setItem("primeiroAcesso", "true");
                        localStorage.setItem("usuario", JSON.stringify(this.usuarioLogado));

                        if(this.usuarioLogado.isImportadoGuara){
                            this._router.navigate(['/financeiro/boleto-guara']);
                        }

                    }).catch(err => {
                        console.log("Falha ao carregar o SETUP: ", err);
                        this.globalsVariablesService.setGlobalsVariables(this.usuarioLogado);
                        localStorage.setItem("usuario", JSON.stringify(this.usuarioLogado));
                        this.cookieService.set('user', JSON.stringify(this.loginModel), 365);
                        this._router.navigate(['/dashboard']);

                        if(this.usuarioLogado.isImportadoGuara){
                            this._router.navigate(['/financeiro/boleto-guara']);
                        }
                    });
                }
            });

        }, error => {
            this.errors = error;
            console.log(this.errors);
           // this._messageService.error('Usuário ou senha incorretos. Por favor tente novamente.');
        });

    }

}
